"use client";
import { rem } from "../../../core/utils/units-converters/rem.mjs";
import { createVarsResolver } from "../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs";
import { useProps } from "../../../core/MantineProvider/use-props/use-props.mjs";
import { useStyles } from "../../../core/styles-api/use-styles/use-styles.mjs";
import { factory } from "../../../core/factory/factory.mjs";
import { Box } from "../../../core/Box/Box.mjs";
import Button_module_default from "../Button.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Button/ButtonGroup/ButtonGroup.tsx
const defaultProps = { orientation: "horizontal" };
const varsResolver = createVarsResolver((_, { borderWidth }) => ({ group: { "--button-border-width": rem(borderWidth) } }));
const ButtonGroup = factory((_props) => {
	const props = useProps("ButtonGroup", defaultProps, _props);
	const { className, style, classNames, styles, unstyled, orientation, vars, borderWidth, mod, attributes, ...others } = useProps("ButtonGroup", defaultProps, _props);
	return /* @__PURE__ */ jsx(Box, {
		...useStyles({
			name: "ButtonGroup",
			props,
			classes: Button_module_default,
			className,
			style,
			classNames,
			styles,
			unstyled,
			attributes,
			vars,
			varsResolver,
			rootSelector: "group"
		})("group"),
		mod: [{ "data-orientation": orientation }, mod],
		role: "group",
		...others
	});
});
ButtonGroup.classes = Button_module_default;
ButtonGroup.varsResolver = varsResolver;
ButtonGroup.displayName = "@mantine/core/ButtonGroup";
//#endregion
export { ButtonGroup };

//# sourceMappingURL=ButtonGroup.mjs.map